var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1156 13.8634L14.9396 22.7593C15.1331 22.9559 15.3633 23.112 15.6169 23.2185C15.8705 23.325 16.1425 23.3799 16.4172 23.3799C16.6919 23.3799 16.964 23.325 17.2176 23.2185C17.4712 23.112 17.7014 22.9559 17.8948 22.7593C18.2824 22.3662 18.5 21.8344 18.5 21.2801C18.5 20.7259 18.2824 20.1941 17.8948 19.801L10.5276 12.3738L17.8948 4.94664C18.2824 4.55354 18.5 4.02178 18.5 3.4675C18.5 2.91322 18.2824 2.38146 17.8948 1.98836C17.7004 1.7939 17.4697 1.64006 17.2162 1.53565C16.9626 1.43124 16.6911 1.37832 16.4172 1.37992C16.1433 1.37832 15.8718 1.43124 15.6183 1.53565C15.3647 1.64006 15.1341 1.7939 14.9396 1.98836L6.1156 10.8842C5.92054 11.0792 5.76571 11.3113 5.66006 11.5669C5.5544 11.8226 5.5 12.0968 5.5 12.3738C5.5 12.6508 5.5544 12.925 5.66006 13.1807C5.76571 13.4364 5.92053 13.6684 6.1156 13.8634Z",
    fill: "#143578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/Prev.0dc6680fe69369b89a2d8811bfcd96d1.svg";
export { ForwardRef as ReactComponent };